import { render, staticRenderFns } from "./happy-space-tab.vue?vue&type=template&id=97a63948&scoped=true&"
import script from "./happy-space-tab.vue?vue&type=script&lang=js&"
export * from "./happy-space-tab.vue?vue&type=script&lang=js&"
import style0 from "./happy-space-tab.vue?vue&type=style&index=0&id=97a63948&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a63948",
  null
  
)

export default component.exports